export function defineChatEventProps() {
    return {
        chat: { type: Object, required: true },
        event: { type: Object, required: true },
    };
}
//# sourceMappingURL=defineChatEventProps.js.map